import type { optionType, paymentItemType, PaymentOptionAssets } from "utils";
import maestro from "../../public/assets/payment/maestro-logo.svg";
import masterCard from "../../public/assets/payment/mastercard-logo.svg";
import visa from "../../public/assets/payment/visa-logo.svg";
import stripe from "../../public/assets/payment/stripeLogo.svg";
import warning from "../../public/assets/icons/warning.svg";
import success from "../../public/assets/icons/success.svg";
import error from "../../public/assets/icons/error.svg";

export const paymentItems: paymentItemType[] = [
  {
    label: "stripePayment",
    value: 1,
    isVisible: true,
    pictures: [
      { src: stripe, width: 45 },
      { src: masterCard, width: 25 },
      { src: maestro, width: 25 },
      { src: visa, width: 25 },
    ],
  },
];

export const paymentOptionsAssets: PaymentOptionAssets = {
  warning: {
    src: warning,
    width: 20,
  },
  success: {
    src: success,
    width: 20,
  },
  error: {
    src: error,
    width: 20,
  },
};

export const countryOptions: optionType[] = [
  { value: "AT", label: "country_at" },
  { value: "SK", label: "country_sk" },
];
